import { axiosInstance } from ".";

export const getAllPackages = async (params) =>
  await axiosInstance.get(`/packages`, { params });

export const addNewPackage = async ({ package: pkg }) =>
  await axiosInstance.post(`/packages`, { package: pkg });

export const getSinglePackage = async (params) =>
  await axiosInstance.get(`/packages/${params}`);

export const editPackage = async ({ package: pkg, id }) =>
  await axiosInstance.patch(`/packages/${id}`, {
    package: pkg
  });

export const deletePackage = async (id) =>
  await axiosInstance.delete(`/packages/${id}`);
